import React, { useState, useEffect, useRef } from "react";
import "../achivments/achivments.css";
import CountUp from "react-countup";
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import awardsmap from "../../images/awardsmap.svg";

const avardsdata = [
    {
        id: 0,
        title: "Top Machine Learning Company",
        logo: require('../../images/awardsdataimg1.png')
    },
    {
        id: 1,
        title: "AR/VR Development Company",
        logo: require('../../images/awardsdataimg2.png')
    },
    {
        id: 2,
        title: "Top Immersive Language Experiences Company",
        logo: require('../../images/awardsdataimg1.png')
    },
    {
        id: 3,
        title: "Virtual Shoppinge Experiences Company",
        logo: require('../../images/awardsdataimg2.png')
    },
    {
        id: 4,
        title: "Global  Fall 2023",
        logo: require('../../images/awardsdataimg3.png')
    },
    {
        id: 5,
        title: "Global  Spring 2024",
        logo: require('../../images/awardsdataimg4.png')
    },
    {
        id: 6,
        title: "Top Machine Learning Company",
        logo: require('../../images/awardsdataimg1.png')
    },
    {
        id: 7,
        title: "AR/VR Development Company",
        logo: require('../../images/awardsdataimg2.png')
    },
    {
        id: 8,
        title: "Top Machine Learning Company",
        logo: require('../../images/awardsdataimg1.png')
    },
    {
        id: 9,
        title: "AR/VR Development Company",
        logo: require('../../images/awardsdataimg2.png')
    },
];

const Achivments = () => {
    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, []);
    const [hasStarted, setHasStarted] = useState(false);
    const sectionRef = useRef(null);


    //on scroll activate counter
    useEffect(() => {
        const handleScroll = () => {
            if (!sectionRef.current) return;

            const sectionTop = sectionRef.current.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;

            if (sectionTop < windowHeight * 0.8 && !hasStarted) {
                setHasStarted(true);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [hasStarted]);

    const counters = [
        { id: 0, value: 35, label: "Industry professionals" },
        { id: 1, value: 30, label: "Completed Projects" },
        { id: 2, value: 7, label: "Awards Won" },
    ];


    //achivments slider
    const sliderRef = useRef(null);

    useEffect(() => {
        const slider = sliderRef.current;

        const startScrolling = () => {
            if (slider) {
                const scrollWidth = slider.scrollWidth;
                const clientWidth = slider.clientWidth;

                let scrollLeft = 0;

                const scroll = () => {
                    scrollLeft += 1; // Adjust speed here
                    if (scrollLeft >= scrollWidth - clientWidth) {
                        scrollLeft = 0; // Reset for seamless looping
                    }
                    slider.scrollLeft = scrollLeft;
                };

                const interval = setInterval(scroll, 10); // Adjust interval for smooth scrolling
                return () => clearInterval(interval);
            }
        };

        return startScrolling();
    }, []);


    return (
        <section className="achivments-main" data-aos='fade-up'>
            <div className="awards-content">
                <div className="A-title" data-aos='fade-up'>
                    <span>Achievements</span>
                    <h1>We excel globally in remarkable projects.</h1>
                    <p className="title-text">
                    We possess extensive experience handling remarkable global projects, demonstrating our capability to deliver exceptional results across diverse landscapes.
                    </p>
                </div>
                <div className="achievements-counter" ref={sectionRef} data-aos='fade-up'>
                    {counters.map((counter) => (
                        <div className="counter-item" key={counter.id}>
                            <li>
                                <p>
                                    {hasStarted ? (
                                        <CountUp start={0} end={counter.value} duration={4.5} />
                                    ) : (
                                        0
                                    )}
                                </p>
                                <span>+</span>
                            </li>
                            <h3>{counter.label}</h3>
                        </div>
                    ))}
                </div>
                <img className="awardsmap" src={awardsmap} alt="Awards Map" data-aos='fade-up' />
            </div>
            <div className="awards-slider" ref={sliderRef} data-aos='fade'>

                {[...avardsdata].map((award) => (
                    <div className="award-item" key={award.id}>
                        <img src={award.logo} alt={award.title} />
                        <p>{award.title}</p>
                    </div>
                ))}

            </div>
        </section>
    );
};

export default Achivments;
